document.addEventListener("DOMContentLoaded", (event) => {
    const nativeSearch = document.querySelector(
      '.header__search search-form input[type="search"]'
    );
    const superSearch = document.querySelector(".super-search");
    const searchSuperSearch = superSearch.querySelector('input[type="search"]');
    const closeButton = superSearch.querySelector(".close-super-search");
    const rootHtml = document.getElementsByTagName("html")[0];
  
    function getCleanUrl() {
      const pathSegments = window.location.pathname.split("/").filter(Boolean);
  
      let localeSegment = pathSegments.find((segment) =>
        /^[a-z]{2}-[a-z]{2}$/.test(segment)
      );
  
      if (!localeSegment) {
        localeSegment = pathSegments.find((segment) =>
          /^[a-z]{2}$/.test(segment)
        );
      }
  
      return localeSegment ? `/${localeSegment}` : "";
    }
  
    nativeSearch.addEventListener("click", (event) => {
      event.preventDefault();
      if (window.Shopify.locale !== "es") {
        window.history.pushState({}, document.title, `${getCleanUrl()}`, "");
      } else {
        window.history.pushState({}, document.title, "/", "");
      }
      superSearch.classList.add("show");
      document.body.classList.add("overflow-hidden");
      rootHtml.classList.add("overflow-hidden");
      document.body.querySelector(".overlay").classList.add("is-visible");
      const overlay = document.querySelector(".overlay.is-visible");
  
      setTimeout(() => {
        searchSuperSearch.focus();
      }, 300);
  
      overlay?.addEventListener("click", (event) => {
        superSearch.classList.remove("show");
        document.body.classList.remove("overflow-hidden");
        rootHtml.classList.remove("overflow-hidden");
        document.body.querySelector(".overlay").classList.remove("is-visible");
        window.history.pushState({}, document.title, `${getCleanUrl()}`, "");
      });
    });
  
    closeButton?.addEventListener("click", (event) => {
      superSearch.classList.remove("show");
      document.body.classList.remove("overflow-hidden");
      rootHtml.classList.remove("overflow-hidden");
      document.body.querySelector(".overlay").classList.remove("is-visible");
    });
  });
  